angular.module('unica_invitation_transfer_event.invitation_transfer_event_services')

.factory('InvitationTransferEventListService', function ($http, getBaseApiURL) {

	var invitationTransferEventListService = {};

	invitationTransferEventListService.list = function (eventId, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-transfer-event/list/' + eventId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_transfers_event;
			}

		});

	};

	invitationTransferEventListService.get = function (invitationTransferEventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-transfer-event/detail/' + invitationTransferEventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_transfer_event;
			}

		});

	};


	invitationTransferEventListService.search = function (eventId, term)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-transfer-event/search/' + eventId,
			data: {
				search: term
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_transfers_event;
			}

		});
	};

	invitationTransferEventListService.exportTransferEvent = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/invitation-transfer-event/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};
	

	return invitationTransferEventListService;
});